import { render, staticRenderFns } from "./Specifications.vue?vue&type=template&id=7a666154&scoped=true"
import script from "./Specifications.vue?vue&type=script&lang=js"
export * from "./Specifications.vue?vue&type=script&lang=js"
import style0 from "./Specifications.vue?vue&type=style&index=0&id=7a666154&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a666154",
  null
  
)

export default component.exports